module.exports = "/images/scheduled.gif";